/**
 * Redirects active subscribers away from the registration flow.
 * Active subscribers already have a subscription and should not re-register.
 */
export default defineNuxtRouteMiddleware(() => {
  const userStore = useUserStore();
  const { homePath } = useHome();

  if (userStore.isActiveUser) {
    return navigateTo(homePath.value as string);
  }
});
